import {
  IRegMenByPeriodResponse,
  IRegMenConsolidateResponse,
  IRegMenReportPerson,
} from "~/entity/RegMenReports";

/** Базовые колонки отчёта по периоду (ключи строк после маппинга). */
export const PERIOD_BASE_OPTIONS = [
  "DealerName",
  "INN",
  "filial",
  "FO",
  "subject",
  "city",
  "entfCode",
  "entfSuccessorCode",
  "entfSuccessorNo",
];

/** Фиксированные колонки направлений отчёта по периоду: поле ответа + ключ перевода. */
export const PERIOD_DIRECTION_COLUMNS = [
  { key: "leaderRegionalSalesManager", titleKey: "headSales" },
  { key: "regionalSalesManager", titleKey: "managerSales" },
  { key: "leaderRegionalServiceManager", titleKey: "headService" },
  { key: "regionalServiceManager", titleKey: "managerService" },
  { key: "leaderRegionalMarketingManager", titleKey: "headMarketing" },
  { key: "regionalMarketingManager", titleKey: "managerMarketing" },
  { key: "leaderRegionalCorporateManager", titleKey: "headCorporate" },
  { key: "regionalCorporateManager", titleKey: "managerCorporate" },
  { key: "leaderRegionalUsedCarManager", titleKey: "headUsedCar" },
  { key: "regionalUsedCarManager", titleKey: "managerUsedCar" },
] as const;

const formatPersons = (
  persons: IRegMenReportPerson[] | null | undefined,
  temporaryLabel: string,
): string[] =>
  (persons ?? [])
    .filter(
      (person): person is IRegMenReportPerson & { fullname: string } =>
        !!person?.fullname,
    )
    .map((person) =>
      person.assignmentType === "temporary"
        ? `${person.fullname} (${temporaryLabel})`
        : person.fullname,
    );

/** Строки таблицы отчёта по периоду: дилер + колонки рук/РМ по направлениям
 * (в ячейке направления — массив ФИО, рендерится списком). */
export const mapPeriodRows = (
  response: IRegMenByPeriodResponse | undefined,
  temporaryLabel: string,
) =>
  (response?.items ?? []).map((item) => {
    const row: Record<string, unknown> = {
      dealerId: item.dealerId,
      quarter: item.quarter,
      year: item.year,
      DealerName: item.dealerName ?? "",
      INN: item.inn ?? "",
      filial: item.code ?? "",
      FO: item.fo ?? "",
      subject: item.subject ?? "",
      city: item.city ?? "",
      entfCode: item.entfCode ?? "",
      entfSuccessorCode: item.entfSuccessorCode ?? "",
      entfSuccessorNo: item.entfSuccessorNo ?? "",
    };
    PERIOD_DIRECTION_COLUMNS.forEach(({ key }) => {
      row[key] = formatPersons(item[key], temporaryLabel);
    });
    return row;
  });

/** Строки сводного отчёта: statistic раскладывается в колонки-периоды. */
export const mapConsolidateRows = (
  response: IRegMenConsolidateResponse | undefined,
) =>
  (response?.items ?? []).map((item) => ({
    regionalManager: item.regionalManager,
    role: item.role,
    ...item.statistic,
  }));
